import { Translation } from '@shared/types/translation';

export const SERVICE_MANAGEMENT_LABELS = {
  EQUIPMENT_DESCRIPTION: {
    english: 'Select equipment item that require service.',
    polish: 'Wybierz aparaturę wymagającą serwisu.',
  },
  // Shared across UPDATE_SR_STATUS_LABELS and RESCHEDULE_SR_LABELS in the
  // legacy labels.ts — both define an identical "Send email" checkbox
  // label, so it's kept as one key here instead of duplicated.
  FIELD_NOTIFY: {
    english: 'Send email',
    polish: 'Wyślij e-mail',
  },
  RESCHEDULE_CONFIRM_TITLE: {
    english: 'Review Reschedule',
    polish: 'Sprawdź zmianę terminu',
  },
  RESCHEDULE_CONFIRM_SUBTITLE: {
    english:
      'Please review the updated schedule before confirming. This will notify relevant users.',
    polish:
      'Sprawdź zaktualizowany harmonogram przed potwierdzeniem. Spowoduje to powiadomienie odpowiednich użytkowników.',
  },
  RESCHEDULE_CONFIRM_NOTIFY: {
    english:
      'Notify the client & technician that an email containing the relevant details will be sent to them.',
    polish:
      'Powiadom klienta i technika, że zostanie do nich wysłany e-mail z odpowiednimi szczegółami.',
  },
  RESCHEDULE_CONFIRM_SECTION_CURRENT: {
    english: 'Current Schedule Details',
    polish: 'Szczegóły zaplanowanej wizyty',
  },
  RESCHEDULE_CONFIRM_SECTION_UPDATED: {
    english: 'Updated Schedule Details',
    polish: 'Szczegóły zaktualizowanego terminu',
  },
  RESCHEDULE_BUTTON_SUBMIT: {
    english: 'Confirm Reschedule',
    polish: 'Potwierdź zmianę terminu',
  },
  // Shared by RESCHEDULE_SR_LABELS.TECHNICIAN_TOOLTIP_NO_WINDOW (RescheduleModal)
  // and ASSIGN_TECHNICIAN_LABELS.TECHNICIAN_TOOLTIP_NO_WINDOW /
  // ADMIN_TOOLTIP_NO_WINDOW (EligibleTechnicianDropdown) — all three hold
  // identical tooltip text.
  TECHNICIAN_TOOLTIP_NO_WINDOW: {
    english: 'Please select a start date and end date first.',
    polish: 'Najpierw wybierz datę początkową i końcową.',
  },
  // Shared by RESCHEDULE_SR_LABELS.FIELD_TASK_FORM_ID (RescheduleModal) and
  // ASSIGN_TECHNICIAN_LABELS.FIELD_TASK_FORM_ID (AssignTechnicianModal) —
  // identical field label text.
  FIELD_TASK_FORM_ID: {
    english: 'Task Form ID',
    polish: 'ID formularza zadania',
  },
  FIELD_TASK_FORM_NAME: {
    english: 'Task Form Name',
    polish: 'Nazwa formularza zadania',
  },
  ERROR_NO_CERTIFICATE_LINKED: {
    english: 'This task form does not have a certificate',
    polish: 'Ten formularz zadania nie ma certyfikatu',
  },
  // Shared by ASSIGN_TECHNICIAN_LABELS.FIELD_CERTIFICATE_TEMPLATE_NAME
  // (AssignTechnicianModal) and RESCHEDULE_SR_LABELS.FIELD_CERTIFICATE_TEMPLATE_NAME
  // (RescheduleModal) — identical field label text.
  FIELD_CERTIFICATE_TEMPLATE_NAME: {
    english: 'Certificate Template Name',
    polish: 'Nazwa szablonu certyfikatu',
  },
  UNFULFILLED_TITLE: {
    english: 'Unfulfilled Visit',
    polish: 'Niezrealizowana wizyta',
  },
  FIELD_MISSED_VISIT_REASON: {
    english: 'Reason for Unfulfilled Visit',
    polish: 'Powód niezrealizowanej wizyty',
  },
  ERROR_NOTES_OR_ATTACHMENT_REQUIRED: {
    english:
      'Admin Notes or at least one attachment is required to complete this Service Request.',
    polish:
      'Aby ukończyć to zgłoszenie serwisowe, wymagane są uwagi administratora lub co najmniej jeden załącznik.',
  },
  MY_TASKS_SEARCH_PLACEHOLDER: {
    english: 'Search by request ID, client name, or employee name',
    polish:
      'Szukaj po ID zgłoszenia, nazwie klienta lub imieniu i nazwisku pracownika',
  },
  // The 3 rotating single-field placeholders below aren't individually in
  // the reference sheet, but each is a natural clause split out of the
  // combined sentence above (given, not guessed).
  // TODO: still needs explicit confirmation against a ticket row before
  // being treated as fully verified
  MY_TASKS_SEARCH_PLACEHOLDER_REQUEST_ID: {
    english: 'Search by request ID',
    polish: 'Szukaj po ID zgłoszenia',
  },
  MY_TASKS_SEARCH_PLACEHOLDER_CLIENT_NAME: {
    english: 'Search by client name',
    polish: 'Szukaj po nazwie klienta',
  },
  MY_TASKS_SEARCH_PLACEHOLDER_EMPLOYEE_NAME: {
    english: 'Search by employee name',
    polish: 'Szukaj po imieniu i nazwisku pracownika',
  },
  SECTION_RESPONSE_ATTACHMENTS: {
    english: 'Response Attachments',
    polish: 'Załączniki odpowiedzi',
  },
} as const satisfies Record<string, Translation>;
